import axios from 'axios'
import * as Yup from 'yup'

export const validationSchema = Yup.object({
  acceptedTerms: Yup.boolean().required('Required').oneOf([true], 'You must accept the terms and conditions.'),
  companyName: Yup.string().when('isFirmProfile', {
    is: true,
    then: Yup.string().max(100, 'Business name must be at most 100 characters').required('Required'),
  }),
  furloughCode: Yup.string().when('isFurloughReferral', {
    is: true,
    then: Yup.string().required('Required'),
  }),
  firstName: Yup.string().max(20, 'First name must be at most 20 characters').required('Required'),
  lastName: Yup.string().max(20, 'Last name must be at most 20 characters').required('Required'),
  password: Yup.string()
    .max(20, 'Must be 20 characters or less')
    .min(7, 'Must be 7 characters or more')
    .required('Required'),
  confirmPassword: Yup.string()
    .max(20, 'Must be 20 characters or less')
    .required('Required'),
  email: Yup.string()
    .email('Please enter a valid email.')
    .min(6, 'Please enter a valid email.')
    .required('Required'),
  isFirmProfile: Yup.boolean().required('Required').oneOf([true, false], 'Required.'),
})

export const calcPasswordStrength = (password: string) => {
  const pw = password || ''
  const pwLength = pw.length
  const hasUpper = /[A-Z]/.test(pw)
  // eslint-disable-next-line
  const hasSpecial = /[-!$%^&*()@#_+|~=`{}\[\]:";'<>?,.\/]/.test(pw)

  let strength = 0
  let strengthMsg =
    pwLength < 7
      ? 'Add at least 7 characters.'
      : 'We suggest making it 7+ characters in length with 1+ capital letter and 1+ special character (!, $, &, etc).'

  if (pwLength >= 7) {
    strength = 25
    strengthMsg = 'Password must be more then 7 characters'
  }
  if (pwLength > 7 && !hasSpecial) {
    strength = 50
    strengthMsg = 'Try adding a special character (!, $, &, etc.).'
  } else if (pwLength > 7 && !hasUpper) {
    strength = 50
    strengthMsg = 'Try adding at least 1 capital letter.'
  }
  if (pwLength > 7 && hasUpper && hasSpecial) {
    strength = 75
    strengthMsg = 'Password is strong.'
  }
  if (pwLength > 16 && hasUpper && hasSpecial) {
    strength = 100
    strengthMsg = 'Your password is very strong'  
  }  
  return {
    strength,
    strengthMsg,
  }
}

export const checkDuplicateEmail = async(email: string) => {
  let valid=false
  let message='This email is already associated with an account. Please login or use a different email address.'
  await axios
    .post(
      `${process.env.REACT_APP_V1_ENDPOINT}/public/users/validemail`,
      { email: email },
      { headers: { auth: 'null' } },
    )
    .then((response) => {
      if (response.status === 200) {
        valid = response.data
      } else {
        valid = false
        message = 'Error encountered while fetching the response'
      }
    })
    .catch((error) => {
      console.log(error)
      message = 'Error encountered while fetching the response'
    })
  return {valid,message,}
}